import React, {useContext} from "react";
import { Pagination } from "react-instantsearch-hooks-web";
import FilterContext from "../Context/FilterContext";

const CustomPagination = props => {
    const { setLoading } = useContext(FilterContext)

    const onClick = () => {
        if (setLoading) setLoading(true)
    }

    return (
        <Pagination
            onClick={onClick}
            classNames={{
                list: 'flex items-center justify-center gap-2 text-sm',
                link: 'px-2 py-1 select-none',
                item: 'rounded-lg shadow bg-white',
                selectedItem: 'bg-indigo-800 text-white',
                disabledItem: 'bg-gray-50 text-gray-400 cursor-not-allowed',
                noRefinementRoot: 'hidden'
            }}
        />
    )
}

export default CustomPagination